module.exports = __webpack_public_path__ + "img/233-40af36.png";